export default "__VITE_ASSET__55781724__"